// extracted by mini-css-extract-plugin
module.exports = {"image":"SelectCategoryModal_image__2t4zI","row":"SelectCategoryModal_row__iNVZq","actions":"SelectCategoryModal_actions__2ofqa"};